module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm1"
    }
  }, [_vm._v("Preface")]), _vm._v(" by Eva Brann")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm2"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm3"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm4"
    }
  }, [_c('strong', [_vm._v("Introduction.")]), _vm._v(" The Subject Matter, Thesis, and Structure of This Study")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_c('strong', [_vm._v("Part One. Klein on Husserl’s Phenomenology and the History of Science")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1"
    }
  }, [_c('strong', [_vm._v("Chapter One.")]), _vm._v(" Klein’s and Husserl’s Investigations of the Origination of Mathematical Physics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec1"
    }
  }, [_vm._v("§ 1. The Problem of History in Husserl’s Last Writings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec2"
    }
  }, [_vm._v("§ 2. The Priority of Klein’s Research on the Historical Origination of the Meaning of Mathematical Physics over Husserl’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec3"
    }
  }, [_vm._v("§ 3. The Importance of Husserl’s Last Writings for Understanding Klein’s Nontraditional Investigations of the History and Philosophy of Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec4"
    }
  }, [_vm._v("§ 4. Klein’s Commentary on Husserl’s Investigation of the History of the Origin of Modern Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#sec5"
    }
  }, [_vm._v("§ 5. The “Curious” Relation between Klein’s Historical Investigation of Greek and Modern Mathematics and Husserl’s Phenomenology")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2"
    }
  }, [_c('strong', [_vm._v("Chapter Two.")]), _vm._v(" Klein’s Account of the Essential Connection between Intentional and Actual History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#sec6"
    }
  }, [_vm._v("§ 6. The Problem of Origin and History in Husserl’s Phenomenology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#sec7"
    }
  }, [_vm._v("§ 7. The Internal Motivation for Husserl’s Seemingly Late Turn to History")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3"
    }
  }, [_c('strong', [_vm._v("Chapter Three.")]), _vm._v(" The Liberation of the Problem of Origin from Its Naturalistic Distortion: The Phenomenological Problem of Constitution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#sec8"
    }
  }, [_vm._v("§ 8. Psychologism and the Problem of History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#sec9"
    }
  }, [_vm._v("§ 9. Internal Temporality and the Problem of the Sedimented History of Significance")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter4"
    }
  }, [_c('strong', [_vm._v("Chapter Four.")]), _vm._v(" The Essential Connection between Intentional and Actual History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#sec10"
    }
  }, [_vm._v("§ 10. The Two Limits of the Investigation of the Temporal Genesis Proper to the Intrinsic Possibility of the Intentional Object")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#sec11"
    }
  }, [_vm._v("§ 11. The Transcendental Constitution of an Identical Object Exceeds the Sedimented Genesis of Its Temporal Form")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#sec12"
    }
  }, [_vm._v("§ 12. The Distinction between the Sedimented History of the Immediate Presence of an Intentional Object and the Sedimented History of Its Original Presentation")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5"
    }
  }, [_c('strong', [_vm._v("Chapter Five.")]), _vm._v(" The Historicity of the Intelligibility of Ideal Significations and the Possibility of Actual History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#sec13"
    }
  }, [_vm._v("§ 13. The Problem of ‘Iστορ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v("α underlying Husserl’s Concept of Intentional History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#sec14"
    }
  }, [_vm._v("§ 14. Two Senses of Historicity and the Meaning of the Historical Apriori")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter5#sec15"
    }
  }, [_vm._v("§ 15. Historicity as Distinct from Both Historicism and the History of the Ego")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Six.")]), _vm._v(" Sedimentation and the Link between Intentional History and the Constitution of a Historical Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 16. Maintaining the Integrity of Knowledge Requires Inquiry into Its Original Historical Discovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 17. Two Presuppositions Are Necessary to Account for the Historicity of the Discovery of the Ideal Objects of a Science Such as Geometry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 18. Sedimentation and the Constitution of a Geometrical Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 19. The Historical Apriori of Ideal Objects and Historical Facts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 20. The Historical Apriori Is Not a Concession to Historicism")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Seven.")]), _vm._v(" Klein’s Departure from the Content but Not the Method of Husserl’s Intentional-Historical Analysis of Modern Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 21. The Contrast between Klein’s Account of the Actual Development of Modern Science and Husserl’s Intentional Account")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 22. Sedimentation and the Method of Symbolic Abstraction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 23. The Establishment of Modern Physics on the Foundation of a Radical Reinterpretation of Ancient Mathematics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 24. Vieta’s and Descartes’s Inauguration of the Development of the Symbolic Science of Nature: Mathematical Physics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 25. Open Questions in Klein’s Account of the Actual Development of Modern Science")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part Two. Husserl and Klein on the Method and Task of Desedimenting the Mathematization of Nature")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Eight.")]), _vm._v(" Klein’s Historical-Mathematical Investigations in the Context of Husserl’s Phenomenology of Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 26. Summary of Part One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 27. Klein’s Failure to Refer to Husserl in "), _c('em', [_vm._v("Greek Mathematical Thought and the Origin of Algebra")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 28. Critical Implications of Klein’s Historical Research for Husserl’s Phenomenology")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Nine.")]), _vm._v(" The Basic Problem and Method of Klein’s Mathematical Investigations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 29. Klein’s Account of the Limited Task of Recovering the Hidden Sources of Modern Symbolic Mathematics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 30. Klein’s Motivation for the Radical Investigation of the Origins of Mathematical Physics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 31. The Conceptual Battleground on Which the Scholastic and the New Science Fought")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Ten.")]), _vm._v(" Husserl’s Formulation of the Nature and Roots of the Crisis of European Sciences")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 32. Klein’s Uncanny Anticipation of Husserl’s Treatment of the Historical Origins of Scientific Concepts in the "), _c('em', [_vm._v("Crisis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 33. Historical Reference Back to Origins and the Crisis of Modern Science")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 34. Husserl’s Reactivation of the Sedimented Origins of the Modern Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 35. Husserl’s Fragmentary Analyses of the Sedimentation Responsible for the Formalized Meaning Formations of Modern Mathematics and Klein’s Inquiry into Their Origin and Conceptual Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Eleven.")]), _vm._v(" The “Zigzag” Movement Implicit in Klein’s Mathematical Investigations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 36. The Structure of Klein’s Method of Historical Reflection in "), _c('em', [_vm._v("Greek Mathematical Thought and the Origin of Algebra")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twelve.")]), _vm._v(" Husserl and Klein on the Logic of Symbolic Mathematics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 37. Husserl’s Systematic Attempt to Ground the Symbolic Concept of Number in the Concept of "), _c('em', [_vm._v("Anzahl")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 38. Klein on the Transformation of the Ancient Concept of ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς ("), _c('em', [_vm._v("Anzahl")]), _vm._v(") into the Modern Concept of Symbolic Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 39. Transition to Part Three of This Study")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part Three. Non-symbolic and Symbolic Numbers in Husserl and Klein")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Thirteen.")]), _vm._v(" Authentic and Symbolic Numbers in Husserl’s "), _c('em', [_vm._v("Philosophy of Arithmetic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 40. The Shortcomings of "), _c('em', [_vm._v("Philosophy of Arithmetic")]), _vm._v(" and Our Basic Concern")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 41. Husserl on the Authentic Concepts of Multiplicity and Cardinal Number Concepts, and Inauthentic (Symbolic) Number Concepts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 42. The Basic Logical Problem in "), _c('em', [_vm._v("Philosophy of Arithmetic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 43. The Fundamental Shift in Husserl’s Account of Calculational Technique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 44. Husserl’s Account of the Logical Requirements behind Both Calculational Technique and Symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 45. Husserl’s Psychological Account of the Logical Whole Proper to the Concept of Multiplicity and Authentic Cardinal Number Concepts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 46. Husserl on the Psychological Basis for Symbolic Numbers and Logical Technique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 47. Husserl on the Symbolic Presentation of Multitudes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 48. Husserl on the Psychological Presentation of Symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 49. Husserl on the Symbolic Presentation of the Systematic Construction of New Number Concepts and Their Designation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 50. The Fundamental Shift in the Logic of Symbolic Numbers Brought about by the Independence of Signitively Symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 51. The Unresolved Question of the Logical Foundation for Signitively Symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 52. Summary and Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Fourteen.")]), _vm._v(" Klein’s Desedimentation of the Origin of Algebra and Husserl’s Failure to Ground Symbolic Calculation in Authentic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#sec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 53. Implications of Klein’s Desedimentation of the Origin of Algebra for Husserl’s Analyses of the Concept Proper to Number in "), _c('em', [_vm._v("Philosophy of Arithmetic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#sec54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 54. Klein’s Desedimentation of the Two Salient Features of the Foundations of Greek Mathematics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Fifteen.")]), _vm._v(" Logistic and Arithmetic in Neoplatonic Mathematics and in Plato")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#sec55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 55. The Opposition between Logistic and Arithmetic in Neoplatonic Thought")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#sec56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 56. Logistic and Arithmetic in Plato")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 57. Tensions and Issues Surrounding the Role of the Theory of Proportions in Nicomachus, Theon, and Domninus")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Sixteen.")]), _vm._v(" Theoretical Logistic and the Problem of Fractions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#sec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 58. The Ambiguous Relationship between Logistic and Arithmetic in Neoplatonic Mathematics and in Plato")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#sec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 59. The Obstacle Presented by Fractions to Plato’s Demand for a Theoretical Logistic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Seventeen.")]), _vm._v(" The Concept of ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#sec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 60. The Connection between Neoplatonic Mathematics and Plato’s Ontology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#sec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 61. Counting as the Fundamental Phenomenon Determining the Meaning of ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#sec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 62. “Pure” ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#sec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 63. Why Greek Theoretical Arithmetic and Logistic Did Not Directly Study ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Eighteen.")]), _vm._v(" Plato’s Ontological Conception of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#sec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 64. The Interdependence of Greek Mathematics and Greek Ontology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#sec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 65. The Pythagorean Context of Plato’s Philosophy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#sec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 66. Plato’s Departure from Pythagorean Science: The Fundamental Role of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" of Pure Monads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#sec67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 67. Δι"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom1.jpg"
    }
  }), _vm._v("νοια as the Soul’s Initial Mode of Access to Nοητ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#sec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 68. The Limits Inherent in the Dianoetic Mode of Access to Nοητ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Nineteen.")]), _vm._v(" Klein’s Reactivation of Plato’s Theory of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom.jpg"
    }
  }), _vm._v("δητικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 69. The Inability of Mathematical Thought to Account for the Mode of Being of Its Objects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 70. The Curious Kind of Kοινων"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v("α Manifest in ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 71. The Kοινων"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v("α Exemplified by ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" as the Key to Solving the Problem of Mέθεξις")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 72. The Kοινων"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v("α Exemplified by ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" Contains the Clue to the “Mixing” of Being and Non-being in the Image")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 73. Partial Clarification of the Aporia of Being and Non-being Holds the Key to the “Arithmetical” Structure of the Nοητ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ν’s Mode of Being")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 74. The Kοινων"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v("α among "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/o_2.jpg"
    }
  }), _vm._v("ν, K"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v("νησις, and Στ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom1.jpg"
    }
  }), _vm._v("σις Composes the Relationship of Being and Non-being")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 75. The Contrast between ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" Mαθηματικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" and ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom.jpg"
    }
  }), _vm._v("δητικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 76. The Foundational Function of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom.jpg"
    }
  }), _vm._v("δητικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 77. The Order of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom.jpg"
    }
  }), _vm._v("δητικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" Provides the Foundation for Both the Sequence of Mathematical ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" and the Relation of Family Descent between Higher and Lower Γένη")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 78. The Inability of the Λ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("γος to “Count” the Mέγιστα Γένη Points to Its Limits and Simultaneously Presents the First ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom.jpg"
    }
  }), _vm._v("δητικ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 79. Θ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom1.jpg"
    }
  }), _vm._v("τερον as the “Twofold in General” Allows for the Articulation of Being and Non-being")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 80. Recognizing “the Other” as the “Indeterminate Dyad”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 81. The “One Itself” as the Source of the Generation of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom.jpg"
    }
  }), _vm._v("δητικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 82. Γένη as ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom.jpg"
    }
  }), _vm._v("δητικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" Provide the Foundation of an Eidetic Logistic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#sec83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 83. Plato’s Postulate of the Separation of All Noetic Formations Renders Incomprehensible the Ordinary Mode of Predication")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty.")]), _vm._v(" Aristotle’s Critique of the Platonic "), _c('em', [_vm._v("Chorismos")]), _vm._v(" Thesis and the Possibility of a Theoretical Logistic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#sec84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 84. Point of Departure and Overview of Aristotle’s Critique")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#sec85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 85. Aristotle’s Problematic: Harmonizing the Ontological Dependence of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" with Their Pure Noetic Quality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#sec86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 86. Aristotle on the Abstractive Mode of Being of Mathematical Objects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#sec87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 87. Aristotle’s Ontological Determination of the Non-generic Unity of ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#sec88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 88. Aristotle’s Ontological Determination of the Unity of ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς as Common Measure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#sec89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 89. Aristotle’s Ontological Determination of the Indivisibility and Exactness of “Pure” ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#sec90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 90. The Influence of Aristotle’s View of Mαθηματικ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom1.jpg"
    }
  }), _vm._v(" on Theoretical Arithmetic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#sec91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 91. Aristotle’s Ontological Conception of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" Makes Possible Theoretical Logistic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-one.")]), _vm._v(" Klein’s Interpretation of Diophantus’s "), _c('em', [_vm._v("Arithmetic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#sec92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 92. Access to Diophantus’s Work Requires Reinterpreting It outside the Context of Mathematics’ Self-interpretation since Vieta, Stevin, and Descartes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#sec93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 93. Diophantus’s Arithmetic as Theoretical Logistic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#sec94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 94. The Referent and Operative Mode of Being of Diophantus’s Concept of ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#sec95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 95. The Ultimate Determinacy of Diophantus’s Concept of Unknown and Indeterminate ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#sec96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 96. The Merely Instrumental, and Therefore Non-ontological and Non-symbolic, Status of the E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icombar.jpg"
    }
  }), _vm._v("δος-Concept in Diophantus’s Calculations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-two.")]), _vm._v(" Klein’s Account of Vieta’s Reinterpretation of the Diophantine Procedure and the Consequent Establishment of Algebra as the General Analytical Art")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 97. The Significance of Vieta’s Generalization of the E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icombar.jpg"
    }
  }), _vm._v("δος-Concept and Its Transformation into the Symbolic Concept of Species")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 98. The Sedimentation of the Ancient Practical Distinction between ‘Saying’ and ‘Thinking’ in the Symbolic Notation Inseparable from Vieta’s Concept of Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 99. The Decisive Difference between Vieta’s Conception of a “General” Mathematical Discipline and the Ancient Idea of a Kαθ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("λου Πραγματε"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v("α")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 100. The Occlusion of the Ancient Connection between the Theme of General Mathematics and the Foundational Concerns of the “Supreme” Science That Results from the Modern Understanding of Vieta’s “Analytical Art” as "), _c('em', [_vm._v("Mathesis Universalis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 101. Vieta’s Ambiguous Relation to Ancient Greek Mathematics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 102. Vieta’s Comparison of Ancient Geometrical Analysis with the Diophantine Procedure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 103. Vieta’s Transformation of the Diophantine Procedure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 104. The Auxiliary Status of Vieta’s Employment of the “General Analytic”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 105. The Influence of the General Theory of Proportions on Vieta’s “Pure,” “General” Algebra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#sec106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 106. Klein’s Desedimentation of the Conceptual Presuppositions Belonging to Vieta’s Interpretation of Diophantine Logistic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-three.")]), _vm._v(" Klein’s Account of the Concept of Number and the Number Concepts in Stevin, Descartes, and Wallis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 107. Stevin’s Idea of a “Wise Age” and His Project for Its Renewal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 108. Stevin’s Critique of the Traditional ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς-Concept")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 109. Stevin’s Symbolic Understanding of "), _c('em', [_vm._v("Numerus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 110. Stevin’s Assimilation of Numbers to Geometrical Formations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 111. Descartes’s Postulation of a New Mode of “Abstraction” and a New Possibility of “Understanding” as Underlying Symbolic Calculation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 112. The Fundamental Cognitive Role Attributed by Descartes to the "), _c('em', [_vm._v("Imaginatio")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 113. Descartes on the Pure Intellect’s Use of the Power of the Imagination to Reconcile the Mathematical Problem of Determinacy and Indeterminacy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 114. Klein’s Reactivation of the “Abstraction” in Descartes as “Symbolic Abstraction”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 115. Klein’s Use of the Scholastic Distinction between “First and Second Intentions” to Fix Conceptually the Status of Descartes’s Symbolic Concepts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 116. Descartes on the Non-metaphorical Reception by the Imagination of the "), _c('em', [_vm._v("Extension")]), _vm._v(" of Bodies as Bridging the Gap between Non-determinate and Determinate Magnitudes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 117. Wallis’s Completion of the Introduction of the New Number Concept")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 118. Wallis’s Initial Account of the Unit Both as the Principle of Number and as Itself a Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 119. Wallis’s Account of the Nought as Also the Principle of Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 120. Wallis’s Emphasis on the Arithmetical Status of the Symbol or Species of the “General Analytic”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 121. The Homogeneity of Algebraic Numbers as Rooted for Wallis in the Unity of the Sign Character of Their Symbols")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#sec122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 122. Wallis’s Understanding of Algebraic Numbers as Symbolically Conceived Ratios")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part Four. Husserl and Klein on the Origination of the Logic of Symbolic Mathematics")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-four.")]), _vm._v(" Husserl and Klein on the Fundamental Difference between Symbolic and Non-symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#sec123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 123. Klein’s Critical Appropriation of Husserl’s "), _c('em', [_vm._v("Crisis")]), _vm._v(" Seen within the Context of the Results of Klein’s Investigation of the Origin of Algebra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#sec124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 124. Husserl and Klein on the Difference between Non-symbolic and Symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#sec125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 125. Husserl on the Authentic Cardinal Number Concept and Klein on the Greek ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς-Concept")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-five.")]), _vm._v(" Husserl and Klein on the Origin and Structure of Non-symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 126. Husserl’s Appeal to Acts of Collective Combination to Account for the Unity of the Whole of Each Authentic Cardinal Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 127. Husserl’s Appeal to Psychological Experience to Account for the Origin of the Categorial Unity Belonging to the Concept of ‘Anything’ Characteristic of the Units Proper to Multiplicities and Cardinal Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 128. The Decisive Contrast between Husserl’s and Klein’s Accounts of the Being of the Units in Non-symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 129. Klein on Plato’s Account of the Purity of Mathematical ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 130. Klein on Plato’s Account of the “Being One” of Each Mathematical ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς as Different from the “Being One” of Mathematical “Monads”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 131. Klein on Plato’s Account of the Non-mathematical Unity Responsible for the “Being One” of the Whole Belonging to Each ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 132. Klein on Plato’s Account of the Solution Provided by ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" E"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom.jpg"
    }
  }), _vm._v("δητικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" to the Aporias Raised by ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom2.jpg"
    }
  }), _vm._v(" Mαθηματικο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 133. Klein on Aristotle’s Account of the Inseparable Mode of the Being of ’Aριθμο"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/icom1.jpg"
    }
  }), _vm._v(" from Sensible Beings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 134. Klein on Aristotle’s Account of the Abstracted Mode of Being of Mathematical Objects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 135. Klein on Aristotle’s Critique of the Platonic Solution to the Problem of the Unity of an ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς-Assemblage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 136. Klein on Aristotle’s Answer to the Question of the Unity Belonging to ’Aριθμ"), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ocom1.jpg"
    }
  }), _vm._v("ς")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#sec137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 137. Klein on Aristotle’s Account of the Origination of the Mο"), _c('em', [_vm._v("ν")]), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/alpcom.jpg"
    }
  }), _vm._v("ς as Measure")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-six.")]), _vm._v(" Structural Differences in Husserl’s and Klein’s Accounts of the Mode of Being of Non-symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#sec138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 138. The Different Accounts of the Mode of Being of the “One” in Husserl, Plato, and Aristotle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#sec139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 139. The Different Accounts of the “Being One” and Ordered Sequence Characteristic of the Wholes Composing Non-symbolic Numbers in Husserl, Plato, and Aristotle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#sec140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 140. The Different Accounts of the Conditions Responsible for the Scope of the Intelligibility of Non-symbolic Numbers in Husserl, Plato, and Aristotle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#sec141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 141. The Structural Differences between Husserl’s and Klein’s Accounts of the Mode of Being of Non-symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#sec142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 142. The Divergence in Husserl’s and Klein’s Accounts of Non-symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-seven.")]), _vm._v(" Digression: The Development of Husserl’s Thought, after "), _c('em', [_vm._v("Philosophy of Arithmetic")]), _vm._v(", on the “Logical” Status of the Symbolic Calculus, the Constitution of Collective Unity, and the Phenomenological Foundation of the "), _c('em', [_vm._v("Mathesis Universalis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#sec143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 143. The Need to Revisit the “Standard View” of the Development of Husserl’s Thought")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-eight.")]), _vm._v(" Husserl’s Accounts of the Symbolic Calculus, the Critique of Psychologism, and the Phenomenological Foundation of the "), _c('em', [_vm._v("Mathesis Universalis")]), _vm._v(" after "), _c('em', [_vm._v("Philosophy of Arithmetic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#sec144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 144. Husserl’s Account of the Symbolic Calculus after "), _c('em', [_vm._v("Philosophy of Arithmetic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#sec145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 145. Husserl’s Critique of "), _c('em', [_vm._v("Philosophy of Arithmetic")]), _vm._v("’s Psychologism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#sec146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 146. Husserl’s Account of the Phenomenological Foundation of the "), _c('em', [_vm._v("Mathesis Universalis")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Twenty-nine.")]), _vm._v(" Husserl’s Critique of Symbolic Calculation in his Schröder Review")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#sec147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 147. The Applicability to Mathematics of Husserl’s Critique of the Symbolic Calculational Technique in Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#sec148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 148. The Two Foci of Husserl’s Schröder Review: Calculus Is Not Deduction and Extensional Logic Is Part of Intensional Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#sec149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 149. The Calculus of Pure Deduction is Neither Deduction per se Nor Its Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#sec150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 150. Extensional Logic’s Subordination to Intensional Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Thirty.")]), _vm._v(" The Separation of Logic from Symbolic Calculation in Husserl’s Later Works")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#sec151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 151. The Contrast of the Schröder Review’s Separation of Logic from Symbolic Calculation with Their Status in "), _c('em', [_vm._v("Philosophy of Arithmetic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#sec152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 152. The Consistency of the "), _c('em', [_vm._v("Crisis")]), _vm._v(" and the Schröder Review regarding Symbolic Calculation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#sec153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 153. The Consistency of "), _c('em', [_vm._v("Formal and Transcendental Logic")]), _vm._v(" and the Schröder Review regarding Symbolic Calculation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#sec154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 154. The Consistency of the "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(" with the Schröder Review’s Framework for Addressing Symbolic Calculation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#sec155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 155. Husserl’s Pre-phenomenological Appraisal of Merely Symbolic Thinking Precludes His Phenomenology from Pursuing Questions regarding the Essence and Logical Justification of the Calculative Method")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#sec156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 156. Husserl’s Account of the Doubly Derivative Meaning of the Formal Nature of the Calculational Procedure Determinative of the Symbolic Calculus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#sec157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 157. Characterization of the Reference to the Empty Universe ‘Any Object Whatever’ of the Elements Belonging to Multitudes and the Units Belonging to Number")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Thirty-one.")]), _vm._v(" Husserl on the Shortcomings of the Appeal to the “Reflexion” on Acts to Account for the Origin of Logical Relations in the Works Leading up to the "), _c('em', [_vm._v("Logical Investigations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#sec158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 158. The Concept of Cardinal Number Is Essentially Different from the Concept of Collecting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#sec159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 159. The Loss of the Contrast between Mathematically Collective Unity and Logically Categorial Unity in Husserl’s Critical Response to Psychologism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#sec160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 160. Husserl’s “Separation” of Logic and Mathematics from Psychologism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#sec161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 161. Husserl and the Systematic Development of the "), _c('em', [_vm._v("Mathesis Universalis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#sec162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 162. Husserl’s Idea of Pure Logic and the Task of Working out the Theoretical Relationship between Formal Mathematics and Formal Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Thirty-two.")]), _vm._v(" Husserl’s Attempt in the "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(" to Establish a Relationship between “Mere” Thought and the “In Itself” of Pure Logical Validity by Appealing to Concrete, Universal, and Formalizing Modes of Abstraction and Categorial Intuition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 163. Husserl’s Account in the "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(" of the Fulfillment of Signification Categories in Formal Objective Categories: Categorial Intuition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 164. Formal Categories Comprising the “State of Affairs” Are "), _c('em', [_vm._v("Not")]), _vm._v(" in Acts of Judgment as Objects of Reflexion But Are the Objects of These Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 165. Different Abstractive Modes of Categorial Intuition: Concrete and Universal Intuition of Categories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 166. Husserl’s Admission That Neither Concrete Nor Universal Categorial Intuition Is Independent of All Sensible Relations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 167. Formalizing Abstraction as Distinct from Both Abstraction as Emphasis on Non-independent Moments and Ideating Abstraction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 168. The Categorial Distinction between Synthetic Forms of Collectiva and States of Affairs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 169. The Unity of the Collection as Such Is "), _c('em', [_vm._v("Neither")]), _vm._v(" Isomorphic "), _c('em', [_vm._v("Nor")]), _vm._v(" Homologous with the Unity of the State of Affairs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 170. The Contrast between Straightforward Perceptions of Sensuously Unified Multitudes and Authentic Intuitions of the Collection as Such")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 171. The Radical Departure of the "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(" from "), _c('em', [_vm._v("Philosophy of Arithmetic")]), _vm._v("’s Account of Number as the Delimitation of an Indeterminate Plurality of Units")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#sec172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 172. Husserl’s Account of “Absolute” Numbers Leaves Unanswered the Question of Whether Either Kind of Abstract Number Has the Status of a Formal Collection")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Thirty-three.")]), _vm._v(" Husserl’s Account of the Constitution of the Collection, Number, and the ‘Universal Whatever’ in "), _c('em', [_vm._v("Experience and Judgment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#sec173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 173. The “Turning of the Regard” to Grasp the Collection as "), _c('em', [_vm._v("One")]), _vm._v(" Object")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#sec174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 174. The Proximity of "), _c('em', [_vm._v("Philosophy of Arithmetic")]), _vm._v("’s Psychologism to "), _c('em', [_vm._v("Experience and Judgment")]), _vm._v("’s Account of the Objective Constitution of the Collection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#sec175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 175. "), _c('em', [_vm._v("Experience and Judgment")]), _vm._v("’s Incomplete Account of the Constitution of Cardinal Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#sec176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 176. The Original Givenness of the ‘Universal Whatever’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#sec177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 177. The Representational Function of the Particular Judgment Form ‘Something or Other’ to Bring About Universality Is Not Fundamentally Different from the Account in "), _c('em', [_vm._v("Philosophy of Arithmetic")]), _vm._v(" of How a Sensuously Unified Multitude Arises")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#sec178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 178. Sum and Substance of Husserl’s Accounts of the Unity of Indeterminate and Determinate Collections and the ‘Anything Whatever’ between "), _c('em', [_vm._v("Philosophy of Arithmetic")]), _vm._v(" and "), _c('em', [_vm._v("Formal and Transcendental Logic")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Thirty-four.")]), _vm._v(" Husserl’s Investigation of the Unitary Domain of Formal Logic and Formal Ontology in "), _c('em', [_vm._v("Formal and Transcendental Logic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 179. The Focus in "), _c('em', [_vm._v("Formal and Transcendental Logic")]), _vm._v(" on the Relationship between Formal Ontology and Apophantic Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 180. Modern Logic and Mathematics Are United by the Formalization of Their Relation to Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 181. The Concept of a Singular Mathematical Manifold and the Most Universal Idea of a Theory of Manifolds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 182. The Idea of a Theory of Manifolds, as the Form of a Deductive Theory, Is “Naturally” Founded on the Categorial Concepts Belonging to the Lower Level of Deductive Theories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 183. The Categorial Unity of the Collection Itself and the Origination of the Form-Concept ‘Any Object Whatever’ Are Relevant to the Task of Accounting for the Relationship between Formal Apophantics and Formal Ontology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 184. The Transition to the Critical Attitude in §§ 44–45 of "), _c('em', [_vm._v("Formal and Transcendental Logic")]), _vm._v(" Does Not Account for the Unity of Formal Ontology and Formal Apophantics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec185",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 185. The Analyses in §§ 44–45 of the Transition to the Critical Attitude and the Emergence of the Broader and Narrower Concepts of Judgment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 186. Critical Elaboration of §§ 44–45: The Absence of a Simple Opposition between Straightforward and Critical Foci Precludes Phenomenological Clarification of the Shift from Formal Ontology to Formal Apophantics")]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 187. The Unitary Province of Formal Logic and Formal Mathematics and Their Epistemological Distinction Is Not Resolved by the Account of the Alternation between the Attitude of Straightforward Judging and That of Supposed Judging as Supposed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 188. Logical Psychologism, Husserl’s Logical and Phenomenological Idealism, and His Failure in "), _c('em', [_vm._v("Formal and Transcendental Logic")]), _vm._v(" to Address the Distinction between the Ontic Meaning Proper to the "), _c('em', [_vm._v("Irrealities")]), _vm._v(" of Collective and Non-collective Categorial Unity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 189. The Formal-Ontological Validity of Formalized Meaning Categories Leads Back to a Possible Individual Whatever or a Possible Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec190",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 190. The Meaning Relation of Formal (Analytical) Categories to Individuals Is Based Not on Phenomenological Analysis But on an Ontological Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 191. The Extension of Formal Analytics’ Epistemological Investigations to Evidence and Experience and Therefore to Transcendental Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 192. The Extension of Both Material and Formal Logical Universalities Bears a Relation to Individuals; the Priority of Individual Judgment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 193. Phenomenological Backward Reference to the Genesis of Judgment Meanings and Judgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 194. The Phenomenological Priority of Objectivities Giving Themselves over All Other Modes of Consciousness; Genetically Secondary Empty Consciousness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 195. Husserl’s Analyses Do Not Present the Phenomenology of the Constitution of the Ideal Existence of the Judgment Content as a Formal Universality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 196. Husserl’s Phenomenological Theory of Judgment Does Not Address the Origin of the Process of Formalization Responsible for the “Algebraization” of the Cores of Formal Logical Judgment Meanings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 197. Husserl’s Thesis of the Independence of Formal Judgment and Ultimate Formal Structures from Algebraization and the Symbolic Indication of the Ultimate Members of Different Propositions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#sec198",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 198. The Non-self-sufficiency of the Ultimate Members of a Proposition. The Non-algebraic Ground of the Identity of Propositional Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Thirty-five.")]), _vm._v(" Klein and Husserl on the Origination of the Logic of Symbolic Numbers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#sec199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 199. Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#sec200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 200. Klein on Vieta’s Identification of the Species of Number with Quantity in General")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#sec201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 201. Klein on Stevin’s Identification of the Mode of Being of Number with the Concept of Number")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#sec202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 202. Klein on Descartes’s Algebraic Reformulation of Geometry as the "), _c('em', [_vm._v("Mathesis Universalis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#sec203",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 203. Klein on Wallis’s Subordination of Geometry to Symbolic Arithmetic in the "), _c('em', [_vm._v("Mathesis Universalis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#sec204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 204. Klein’s Account of the Origination of the Logic of Symbolic Mathematics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#sec205",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 205. Husserl’s Account of the Origination of the Logic of Symbolic Mathematics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter Thirty-six.")]), _vm._v(" Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#sec206",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 206. Klein’s de facto Completion of Husserl’s "), _c('em', [_vm._v("Crisis")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#sec207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 207. Desedimentation of the Formalization Constitutive of the Formal Concept ‘Magnitude in General’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#sec208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("§ 208. Desedimentation of the Historicity of the Origin of Formalization from the Pregiven Life-world")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#sec209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coda: Husserl’s “Platonism” within the Context of Plato’s Own Platonism")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary of Greek and German Terms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Names")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0